import React from 'react'
import _ from 'lodash'
import { Row } from 'antd'
import { P } from 'konsys-ui'
import contents from './detail/contents'
import CompoenentRenderer from './detail/component-renderer'
import { Wrapper } from '../../components/client-components'
import { detailMode, status, statusText } from './constants'
import history from '../../history'
import { theme } from '../../styles/_variables'


export const colorSelector = (e) => {
  switch (e) {
    case status.WAITING:
      return theme.color.purplishGrey
    case status.INPROGRESS:
      return theme.color.info
    case status.CANCEL:
      return theme.color.error
    case status.COMPLETED:
      return theme.color.success
    case status.NOTIFY:
      return theme.charcoalGrey
    default:
      return theme.color.purplishGrey
  }
}

export const textSelector = (e) => {
  switch (e) {
    case status.WAITING:
      return statusText.WAITING
    case status.INPROGRESS:
      return statusText.INPROGRESS
    case status.CANCEL:
      return statusText.CANCEL
    case status.COMPLETED:
      return statusText.COMPLETED
    case status.NOTIFY:
      return statusText.NOTIFY
    case status.WATCHING:
      return statusText.WATCHING
    default:
      return 'ไม่ระบุ'
  }
}

const RowRenderer = ({
  data, mode, onChangeHandler, initialData, mutationVariables, plateHandler, garageHandler, trailerHandler,
}) => data.map(v => <CompoenentRenderer plateHandler={plateHandler} onChangeHandler={onChangeHandler} key={v.id} data={v} mode={mode} mutationVariables={mutationVariables} garageHandler={garageHandler} trailerHandler={trailerHandler}
  initialData={initialData}/>)

const DetailModeHandler = (params, onChangeHandler, mutationVariables, plateHandler, garageHandler, trailerHandler, initialData) => {
  const mode = params.mode.toUpperCase()
  switch (mode) {
    case detailMode.ADD:
      return contents.map((v, i) => (
        <Wrapper key={i}>
          <Row
            align='flex-start'
            // justify='center'
            type='flex'
            gutter={12}
          >
            <RowRenderer data={v}
              mode={mode}
              mutationVariables={mutationVariables}
              plateHandler={plateHandler}
              garageHandler={garageHandler}
              onChangeHandler={onChangeHandler}
              trailerHandler={trailerHandler}
            />
          </Row>
        </Wrapper>
      ))
    case detailMode.EDIT:
    case detailMode.VIEW:
    {
      if (_.isUndefined(params.id)) history.push('/client')
      // mockup data
      return contents.map((v, i) => (
        <Wrapper key={i}>
          <Row
            align='flex-start'
            // justify='center'
            type='flex'
            gutter={12}
          >
            <RowRenderer data={v} mode={mode} mutationVariables={mutationVariables} plateHandler={plateHandler} garageHandler={garageHandler} initialData={initialData} onChangeHandler={onChangeHandler} trailerHandler={trailerHandler}/>
          </Row>
        </Wrapper>
      ))
    }
    default:
      return <P>Something went wrong!</P>
  }
}

export default DetailModeHandler
